import { signal } from "@preact/signals";

const pipWindow = signal<Window | null>(null);
const isSupported = "documentPictureInPicture" in window;

const request = async (width: number, height: number) => {
    if (pipWindow.peek() || !isSupported) {
        return;
    }

    const pip = await window.documentPictureInPicture.requestWindow({
        width,
        height,
    });

    pip.addEventListener("pagehide", () => (pipWindow.value = null));

    Array.from(document.styleSheets).forEach((sheet) => {
        try {
            const rules = Array.from(sheet.cssRules)
                .map((rule) => rule.cssText)
                .join("");
            const style = document.createElement("style");

            style.textContent = rules;
            pip.document.head.appendChild(style);
        } catch (err: unknown) {
            if (sheet.href === null) {
                return;
            }

            const link = document.createElement("link");

            link.rel = "stylesheet";
            link.type = sheet.type;
            link.media = sheet.media.toString();
            link.href = sheet.href;
            pip.document.head.appendChild(link);
        }
    });

    pipWindow.value = pip;
};

const close = () => {
    const pip = pipWindow.peek();

    if (pip) {
        pip.close();
        pipWindow.value = null;
    }
};

const useDocumentPiP = () => {
    return {
        pipWindow,
        isSupported,
        request,
        close,
    };
};

export default useDocumentPiP;
